import React from 'react';

import SearchHashtags from '@src/api/SearchHashtags';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useDelayedState from '@src/hooks/useDelayedState';
import useFlatList from '@src/hooks/useFlatList';
import useSearch from '@src/hooks/useSearch';
import { Hashtag } from '@src/types';

const useSearchHashtags = () => {
  const axiosRequestConfig = useAxiosRequestConfig();
  const { search } = useSearch();
  const delayedSearch = useDelayedState(search);

  const makeRequest = React.useCallback(
    async (offset: number, limit: number): Promise<Hashtag[]> => {
      if (!delayedSearch || delayedSearch.length < 3) {
        return [];
      }
      const response = await SearchHashtags(
        delayedSearch,
        offset,
        limit,
        axiosRequestConfig
      );
      return response.data.hashTags;
    },
    [axiosRequestConfig, delayedSearch]
  );

  return useFlatList(makeRequest);
};

export default useSearchHashtags;
